'use client';
// An add-on photo full size, with its name only (requirements §14: tapping a bundle photo).
import { Close } from './icons';
import { cx, useEscape, useScrollLock } from './ui';

export type Zoom = { src: string | null; name: string };

/** `inside`: positioned over its nearest positioned parent (the booking window) instead of the whole page. */
export default function Lightbox({ zoom, onClose, closeLabel, inside = false }: { zoom: Zoom | null; onClose: () => void; closeLabel: string; inside?: boolean }) {
  useEscape(zoom ? onClose : null);
  useScrollLock(!!zoom && !inside);
  if (!zoom) return null;
  return (
    <div className={cx(inside ? 'absolute z-[9]' : 'fixed z-[70]', 'inset-0 grid place-items-center bg-[rgba(20,4,32,.86)] p-6')} onClick={onClose} role="dialog" aria-modal="true" aria-label={zoom.name}>
      <figure className="m-0 grid max-w-full justify-items-center gap-3">
        {zoom.src && <img src={zoom.src} alt="" className="max-h-[70vh] max-w-full rounded-[22px] object-contain" />}
        <figcaption className="text-center text-[16px] font-extrabold text-white">{zoom.name}</figcaption>
      </figure>
      <button type="button" onClick={onClose} aria-label={closeLabel} className="absolute end-4 top-4 grid h-11 w-11 place-items-center rounded-full bg-white/[.14] text-white"><Close className="h-5 w-5" /></button>
    </div>
  );
}
